import { ResetPasswordForm } from 'components/core-v2'
import { useNavigate } from 'react-router-dom'

import { PATH } from '../../../const'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'

const MainElement = () => {
  const navigate = useNavigate()
  const onSuccess = () => navigate(PATH.login)
  return <ResetPasswordForm onSuccess={onSuccess} />
}

export const ResetPassword = () => (
  <TwoColumnWithImage mainElement={<MainElement />} title="Reset password" />
)
